/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timemark: NonNullable<unknown>, duration: NonNullable<unknown>, progress: NonNullable<unknown> }} Scene_Change_Detection_Progress_StatusInputs */

const en_scene_change_detection_progress_status = /** @type {(inputs: Scene_Change_Detection_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scanning: ${i?.timemark}/${i?.duration} (${i?.progress}%) done`)
};

const fr_scene_change_detection_progress_status = /** @type {(inputs: Scene_Change_Detection_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Analyse : ${i?.timemark}/${i?.duration} (${i?.progress}%) termine`)
};

const de_scene_change_detection_progress_status = /** @type {(inputs: Scene_Change_Detection_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scanvorgang: ${i?.timemark}/${i?.duration} (${i?.progress}%) abgeschlossen`)
};

const it_scene_change_detection_progress_status = /** @type {(inputs: Scene_Change_Detection_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scansione: ${i?.timemark}/${i?.duration} (${i?.progress}%) completata`)
};

const ru_scene_change_detection_progress_status = /** @type {(inputs: Scene_Change_Detection_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сканирование: ${i?.timemark}/${i?.duration} (${i?.progress}%) выполнено`)
};

const es_scene_change_detection_progress_status = /** @type {(inputs: Scene_Change_Detection_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Escaneo: ${i?.timemark}/${i?.duration} (${i?.progress}%) realizado`)
};

const zh_cn2_scene_change_detection_progress_status = /** @type {(inputs: Scene_Change_Detection_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`扫描完成：${i?.timemark}/${i?.duration} (${i?.progress}%)`)
};

const ja_scene_change_detection_progress_status = /** @type {(inputs: Scene_Change_Detection_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`スキャン中: ${i?.timemark}/${i?.duration} (${i?.progress}%) 完了`)
};

const hi_scene_change_detection_progress_status = /** @type {(inputs: Scene_Change_Detection_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`स्कैनिंग: ${i?.timemark}/${i?.duration} (${i?.progress}%) पूर्ण`)
};

const pt_pt2_scene_change_detection_progress_status = /** @type {(inputs: Scene_Change_Detection_Progress_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Escaneamento: ${i?.timemark}/${i?.duration} (${i?.progress}%) concluído`)
};

/**
* | output |
* | --- |
* | "Scanning: {timemark}/{duration} ({progress}%) done" |
*
* @param {Scene_Change_Detection_Progress_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_progress_status = /** @type {((inputs: Scene_Change_Detection_Progress_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Progress_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_change_detection_progress_status(inputs)
	if (locale === "de") return de_scene_change_detection_progress_status(inputs)
	if (locale === "it") return it_scene_change_detection_progress_status(inputs)
	if (locale === "ru") return ru_scene_change_detection_progress_status(inputs)
	if (locale === "es") return es_scene_change_detection_progress_status(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_change_detection_progress_status(inputs)
	if (locale === "ja") return ja_scene_change_detection_progress_status(inputs)
	if (locale === "hi") return hi_scene_change_detection_progress_status(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_change_detection_progress_status(inputs)
	return en_scene_change_detection_progress_status(inputs)
});